__turbopack_context__.v({
  "className": "W0UIFa_className",
  "variable": "W0UIFa_variable",
});
